import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { AlchemyInsightModel } from '../../../models/apiModels';
import { Environment } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { isPostAlchemyFeedbackEnabledSelector, isThirdPartySelector } from '../../app/selectors/contactUsSelector';
import { deeplinkPathSelector } from '../../app/selectors/selfHelpSelectors';
import { SelfHelpIntentGraph } from '../presentationalComponents/SelfHelpIntentGraph';
import { diagnosticError, diagnosticStart, diagnosticTimeout } from '../reduxUpdater/actions/diagnosticActions';
import {
  setUserIsSigningIntoClientApp,
  updateDraftRequest,
} from '../reduxUpdater/actions/modalitySectionActions';
import { dispatchRedirectForSignInLink, dispatchSignInUser, dispatchUpdateDialogId } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getSpinnerStyles } from '../styles/intentGraphStyles';

interface IIntentGraphOwnProps {
  graphInsights: Array<AlchemyInsightModel>;
  correlationId: string;
  areaName: string;
}

const mapStateToProps = (state: IAppState, _ownProps: IIntentGraphOwnProps) => {
  return {
    appVer: state.GlobalState.appVer,
    sourceApp: state.GlobalState.sourceApp,
    market: state.GlobalState.market,
    redirectForSignInLink:
      state.ContactState.ModalitySectionState.redirectForSignInLink,
    isClientApp: state.GlobalState.environment === Environment.nonAgavePane,
    isSignedIn: state.ContactState.ModalitySectionState.isSignedIn,
    safActionMaxRetries: state.ContactState.SharedState.safActionMaxRetries,
    environment: state.GlobalState.environment,
    serviceRequestStarted: state.ContactState.ModalitySectionState.serviceRequestPages?.length > 0,
    tenantInfo: state.GlobalState.tenantInfo,
    isThirdParty: isThirdPartySelector(state),
    deeplinkPath: deeplinkPathSelector(state),
    dialogId: state.ContactState.SelfHelpAlchemyState.dialogId,
    isBcqrRetrieved: state.ContactState.SelfHelpAlchemyState.areSolutionsPresent,
    isPostAlchemyFeedbackEnabled: isPostAlchemyFeedbackEnabledSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchSignInUser,
  dispatchRedirectForSignInLink,
  setUserIsSigningIntoClientApp,
  updateDraftRequest,
  diagnosticStart,
  diagnosticError,
  diagnosticTimeout,
  dispatchUpdateDialogId,
};

export const SelfHelpIntentGraphContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(SelfHelpIntentGraph, getSpinnerStyles));
